import { isTest } from 'ember-simplepractice/utils/is-testing';
import { registerDeprecationHandler } from '@ember/debug';

const ADDRESSED_DEPRECATIONS = ['implicit-injections', 'routing.transition-methods'];

// Remove this file for fix deprecations work or update the handler to target a specific deprecation
// you want work on. Ref: https://guides.emberjs.com/v3.28.0/configuring-ember/handling-deprecations/
export function initialize() {
  registerDeprecationHandler((message, options, next) => {
    if (ADDRESSED_DEPRECATIONS.includes(options.id)) {
      throw new Error(message);
    }

    if (isTest()) return;

    next(message, options);
  });
}

export default { initialize };
